import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { loadMetaCompany } from 'slices/company';
import { useNavigate, useOutletContext } from 'react-router-dom';
//api
import { createBookStore } from 'api/company';
//components
import Title from 'components/backoffice/texts/title';
import { addToFormData } from 'helpers';
import BookStoreForm from 'components/backoffice/forms/bookstoreForm';

const CreateBookStore = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(['backoffice']);
  const companyState = useSelector(loadMetaCompany);
  const navigate = useNavigate();
  const { setTitle } = useOutletContext()

  const fileInputRef = useRef(null);

  const {
    reset
  } = useForm();

  const defaultValues = {
    name: '',
    email: '',
    web_url: '',
    code: '',
    direccion: '',
    telefono: '',
    descripcion_pub: '',
    facebook: '',
    twitter: '',
    latitude: '',
    longitude: '',
    instagram: '',
    business_hours: ''
  }

  useEffect(() => {
    setTitle(t('createbookstore'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  const handleClearFile = (image) => {
    if (image !== undefined) {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const onSubmit = useCallback(async (values) => {
    setIsLoading(true);
    const socialsNetworks = {};
    const appsURLs = {};
    if (values.facebook !== '') {
      socialsNetworks.facebook = values.facebook;
    }
    if (values.twitter !== '') {
      socialsNetworks.twitter = values.twitter;
    }
    if (values.instagram !== '') {
      socialsNetworks.instagram = values.instagram;
    }
    if (values.google_play !== '') {
      appsURLs.google_play = values.google_play;
    }
    if (values.app_store !== '') {
      appsURLs.app_store = values.app_store;
    }

    const {
      code: validateCode = '',
      email: validateEmail = '',
      web_url: validateWebUrl = '',
      direccion: validateAddress = '',
      descripcion_pub: validateDescription = '',
      telefono: validatePhone = '',
      logo: validateLogo = '',
      latitude: validateLatitude = '',
      longitude: validateLongitude = '',
      business_hours: validateBusinessHour = '',
      service
    } = values;

    const servicesData = service ? JSON.stringify([service.id]) : '[]';

    const items = {
      name: values.name,
      email: validateEmail,
      web_url: validateWebUrl,
      code: validateCode,
      direccion: validateAddress,
      telefono: validatePhone,
      descripcion_pub: validateDescription,
      logo: validateLogo,
      longitude: validateLongitude,
      latitude: validateLatitude,
      business_hours: validateBusinessHour,
      parent_affiliate: companyState.payload.company.id,
      redes_sociales: JSON.stringify(socialsNetworks),
      apps_urls: JSON.stringify(appsURLs),
      commission_for_instore_pickup: values.commission_for_instore_pickup,
      shipping_commission: values.shipping_commission,
      services_data: servicesData
    }

    const formData = new FormData()

    addToFormData(formData, items)

    try {
      const { status } = await createBookStore(formData);
      if (status === 201) {
        toast.success(t('creadocorrectamente'));
        handleClearFile(values.logo)
        navigate('/intranet/bookstores', { replace: true });
        reset();
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }, []);

  return (
    <div className="mt-2">
      <Title text={t('createbookstore')} />
      <BookStoreForm
        isEditing={false}
        onSubmitForm={onSubmit}
        fileInputRef={fileInputRef}
        defaultValues={defaultValues}
        beforeTitle={t('createbookstore')}
      />
    </div>
  );
};

export default CreateBookStore;